<template>
  <v-card flat class="filters-sidebar" elevation="3">
    <div class="filters-header">
      <v-icon color="white" size="20">mdi-filter-variant</v-icon>
      <span class="filters-title">Filtros</span>
    </div>

    <v-card-text class="filters-content pa-0">

      <!-- Estado Section -->
      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-tag-multiple</v-icon>
          <span class="section-title-text">Estado</span>
        </div>
        <div class="section-content">
          <v-select
            v-model="localEstado"
            :items="estadosPresupuesto"
            item-text="label"
            item-value="value"
            label="Estado del presupuesto"
            prepend-inner-icon="mdi-clipboard-text"
            color="secondary"
            dense
            outlined
            hide-details
            clearable
            class="filter-field"
            @change="setFilters"
          />
        </div>
      </div>

      <!-- Cliente Section -->
      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-account</v-icon>
          <span class="section-title-text">Cliente</span>
        </div>
        <div class="section-content">
          <v-text-field
            v-model="localClienteNombre"
            label="Razón social"
            prepend-inner-icon="mdi-magnify"
            color="secondary"
            dense
            outlined
            hide-details
            clearable
            class="filter-field"
            @keyup.enter="setFilters"
          />
        </div>
      </div>

      <!-- Fecha de creación -->
      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-calendar-range</v-icon>
          <span class="section-title-text">Fecha de creación</span>
        </div>
        <div class="section-content">
          <v-menu
            v-model="menuDesde"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="localFechaDesde"
                label="Desde"
                prepend-inner-icon="mdi-calendar-start"
                color="secondary"
                dense
                outlined
                hide-details
                readonly
                clearable
                class="filter-field mb-3"
                v-bind="attrs"
                v-on="on"
                @click:clear="setFilters"
              />
            </template>
            <v-date-picker
              v-model="localFechaDesde"
              no-title
              locale="es"
              color="secondary"
              @input="menuDesde = false; setFilters()"
            />
          </v-menu>

          <v-menu
            v-model="menuHasta"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="localFechaHasta"
                label="Hasta"
                prepend-inner-icon="mdi-calendar-end"
                color="secondary"
                dense
                outlined
                hide-details
                readonly
                clearable
                class="filter-field"
                v-bind="attrs"
                v-on="on"
                @click:clear="setFilters"
              />
            </template>
            <v-date-picker
              v-model="localFechaHasta"
              no-title
              locale="es"
              color="secondary"
              @input="menuHasta = false; setFilters()"
            />
          </v-menu>
        </div>
      </div>

      <!-- Montos Section -->
      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-currency-usd</v-icon>
          <span class="section-title-text">Monto total</span>
        </div>
        <div class="section-content">
          <v-text-field
            v-model="localPrecioTotalMin"
            label="Mínimo ($)"
            type="number"
            min="0"
            step="0.01"
            prepend-inner-icon="mdi-arrow-collapse-up"
            color="secondary"
            dense
            outlined
            hide-details
            class="filter-field mb-3"
            @keyup.enter="setFilters"
          />
          <v-text-field
            v-model="localPrecioTotalMax"
            label="Máximo ($)"
            type="number"
            min="0"
            step="0.01"
            prepend-inner-icon="mdi-arrow-collapse-down"
            color="secondary"
            dense
            outlined
            hide-details
            class="filter-field"
            @keyup.enter="setFilters"
          />
        </div>
      </div>

      <!-- Ajustes Section -->
      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-percent</v-icon>
          <span class="section-title-text">Ajustes</span>
        </div>
        <div class="section-content">
          <v-text-field
            v-model="localDescuentoMin"
            label="Descuento mín. (%)"
            type="number"
            min="0"
            max="100"
            prepend-inner-icon="mdi-tag-minus"
            color="secondary"
            dense
            outlined
            hide-details
            class="filter-field mb-3"
            @keyup.enter="setFilters"
          />
          <v-text-field
            v-model="localRecargoMin"
            label="Recargo mín. (%)"
            type="number"
            min="0"
            max="100"
            prepend-inner-icon="mdi-tag-plus"
            color="secondary"
            dense
            outlined
            hide-details
            class="filter-field"
            @keyup.enter="setFilters"
          />
        </div>
      </div>

    </v-card-text>

    <div class="filters-actions">
      <v-btn
        text
        small
        color="grey darken-1"
        class="action-btn mb-2"
        @click="cleanFilters"
      >
        <v-icon small left>mdi-filter-remove</v-icon>
        Limpiar filtros
      </v-btn>
      <v-btn
        depressed
        small
        color="secondary"
        class="action-btn white--text"
        @click="setFilters"
      >
        <v-icon small left>mdi-check</v-icon>
        Aplicar filtros
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "PresupuestoFilters",
  data() {
    return {
      menuDesde: false,
      menuHasta: false,
      localEstado: null,
      localClienteNombre: null,
      localFechaDesde: null,
      localFechaHasta: null,
      localPrecioTotalMin: null,
      localPrecioTotalMax: null,
      localDescuentoMin: null,
      localRecargoMin: null,
      estadosPresupuesto: [
        { value: "CREADO", label: "Creado" },
        { value: "PEDIDO_CREADO", label: "Orden de venta creada" },
      ],
    };
  },
  methods: {
    setFilters() {
      this.$emit("updateFilters", {
        estado: this.localEstado || null,
        clienteNombre: this.localClienteNombre || null,
        fechaDesde: this.localFechaDesde || null,
        fechaHasta: this.localFechaHasta || null,
        precioTotalMin: this.localPrecioTotalMin !== null && this.localPrecioTotalMin !== "" ? Number(this.localPrecioTotalMin) : null,
        precioTotalMax: this.localPrecioTotalMax !== null && this.localPrecioTotalMax !== "" ? Number(this.localPrecioTotalMax) : null,
        descuentoMin: this.localDescuentoMin !== null && this.localDescuentoMin !== "" ? Number(this.localDescuentoMin) : null,
        recargoMin: this.localRecargoMin !== null && this.localRecargoMin !== "" ? Number(this.localRecargoMin) : null,
      });
    },
    cleanFilters() {
      this.localEstado = null;
      this.localClienteNombre = null;
      this.localFechaDesde = null;
      this.localFechaHasta = null;
      this.localPrecioTotalMin = null;
      this.localPrecioTotalMax = null;
      this.localDescuentoMin = null;
      this.localRecargoMin = null;
      this.$emit("clearFilter");
    },
  },
};
</script>

<style scoped>
.filters-sidebar {
  height: calc(100vh - 100px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 20px;
  border-radius: 12px !important;
  background: #ffffff;
}

.filters-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px 12px 0 0;
}

.filters-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.filters-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.filter-section {
  padding: 0;
  margin-bottom: 4px;
}

.section-header {
  background: #f5f7fa;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 2px solid #e1e8ed;
}

.section-icon {
  opacity: 0.9;
}

.section-title-text {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #2c3e50;
}

.section-content {
  padding: 16px;
  background: #ffffff;
}

.filter-field {
  font-size: 0.875rem;
}

.filter-field >>> .v-input__slot {
  min-height: 38px !important;
  background: #fafbfc !important;
}

.filter-field >>> fieldset {
  border-color: #e1e8ed !important;
  border-width: 1px !important;
}

.filters-actions {
  padding: 16px;
  border-top: 1px solid #e1e8ed;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-btn {
  width: 100%;
  height: 38px !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
}

.filters-content::-webkit-scrollbar {
  width: 8px;
}

.filters-content::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 10px;
}

.filters-content::-webkit-scrollbar-thumb {
  background: #9ca3af;
  border-radius: 10px;
}

@media (max-width: 960px) {
  .filters-sidebar {
    height: auto;
    position: relative;
    top: 0;
    margin-bottom: 20px;
  }

  .filters-content {
    max-height: 60vh;
  }
}
</style>
